<template>
  <div class="step3Container">
    <div v-loading="sfzLoading" class="mainContainer">
      <div class="top">
        <div class="title">法定代表人/经营者认证信息</div>
        <div class="cardType">
          <el-form label-width="100px" class="cardform" label-position="left">
            <div style="min-width: 220px">
              <el-form-item label="证件类型" required>
                <el-radio-group
                  v-model="cardType"
                  :disabled="step == 5"
                  @change="typeChange"
                >
                  <el-radio :label="1">身份证</el-radio>
                  <el-radio :label="4">其他证件</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div v-if="cardType == 1" class="uploadImage">
          <div class="left">
            <div class="uploadLeftContainer" style="">
              <el-upload
                :disabled="step == 5"
                class="avatar-uploader"
                :action="returnSaveFile"
                :data="{ sbzjlx: 'sfzZm' }"
                :show-file-list="false"
                :on-success="handleFaceAvatarScuccess"
                :on-preview="handlePictureCardPreview"
                :headers="token"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrlOface" :src="imageUrlOface" class="avatar">
                <img
                  v-else
                  class="vatar-uploader-icon"
                  src="../assets/img/zjrlx.png"
                >
              </el-upload>
              <div
                v-if="isShowLeftDelete"
                v-preventReClick
                class="deleteUpload"
                @click="removeCurImg('rl')"
              >
                <!-- <i class="el-icon-circle-close" /> -->
              </div>
            </div>
            <div class="instruction">证件人像面</div>
          </div>
          <div class="right">
            <div class="uploadRightContainer">
              <el-upload
                :disabled="step == 5"
                class="avatar-uploader"
                :action="returnSaveFile"
                :data="{ sbzjlx: 'sfzFm' }"
                :show-file-list="false"
                :on-success="handleZGAvatarScuccess"
                :headers="token"
                :on-preview="handlePictureCardBacPreview"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrlOfZG" :src="imageUrlOfZG" class="avatar">
                <img
                  v-else
                  class="vatar-uploader-icon"
                  src="../assets/img/zjghx.png"
                >
              </el-upload>
              <div
                v-if="isShowRightDelete"
                v-preventReClick
                class="deleteUpload"
                style=""
                @click="removeCurImg('gh')"
              >
                <!-- <i class="el-icon-circle-close" /> -->
              </div>
            </div>

            <div class="instruction">证件国徽面</div>
          </div>
        </div>
        <div v-else class="uploadImage">
          <div class="centerImg">
            <div class="uploadLeftContainer" style="">
              <el-upload
                :disabled="step == 5"
                :headers="token"
                class="avatar-uploader"
                :action="returnSaveFile"
                :show-file-list="false"
                :on-success="handlePublicAvatarScuccess"
                :on-preview="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="imageUrlOfPublic !== ''"
                  :src="imageUrlOfPublic"
                  class="avatar"
                >
                <img
                  v-else
                  class="vatar-uploader-icon"
                  src="../assets/img/zjrlx.png"
                >
              </el-upload>
              <div
                v-if="isShowCenterDelete"
                v-preventReClick
                class="deleteUploadOther"
                @click="removeCurImg('other')"
              >
                <!-- <i class="el-icon-circle-close" /> -->
              </div>
            </div>
            <div class="instructionCenter">证件正面</div>
          </div>
        </div>
      </div>
      <div v-if="cardType == 1" class="content">
        <div class="idCardInformation">
          <div class="topTitle">身份证件信息</div>
          <el-form
            ref="frForm"
            class="formCon"
            :model="paramConfig"
            :rules="rules"
            label-position="left"
            label-width="98px"
          >
            <div style="display: flex">
              <div style="margin-right: 69px">
                <el-form-item label="姓名:" prop="xm">
                  <el-input
                    v-model="paramConfig.xm"
                    :disabled="step == 5"
                    maxlength="200"
                    placeholder="请输入姓名"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="性别:" prop="xb">
                  <el-select
                    v-model="paramConfig.xb"
                    :disabled="step == 5"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in sexOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div style="margin-right: 69px">
                <el-form-item label="证件号码:" prop="zjhm">
                  <el-input
                    v-model="paramConfig.zjhm"
                    :disabled="step == 5"
                    placeholder="请输入证件号码"
                    maxlength="50"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="民族:" prop="mz">
                  <el-select
                    v-model="paramConfig.mz"
                    :disabled="step == 5"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in mzOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div style="margin-right: 69px">
                <el-form-item label="出生日期:" prop="sr">
                  <el-date-picker
                    v-model="paramConfig.sr"
                    :disabled="step == 5"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择出生日期"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="籍贯:">
                  <el-cascader
                    v-model="jgNum"
                    :disabled="step == 5"
                    style="width: 340px"
                    clearable
                    placeholder=""
                    :props="props"
                    filterable
                    @change="jgChange"
                  />
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div class="dateReal">
                <el-form-item
                  label="有效期限:"
                  label-width="98px"
                  class="is-required"
                  prop="yxqxKs"
                >
                  <el-date-picker
                    v-model="paramConfig.yxqxKs"
                    :disabled="step == 5"
                    width="152.5px"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="this.startTime(paramConfig.yxqxJs)"
                  />
                  <div
                    class=""
                    style="
                      display: inline-block;
                      width: 35px;
                      height: 39px;
                      line-height: 39px;
                      text-align: center;
                    "
                  >
                    至
                  </div>
                  <el-date-picker
                    v-model="paramConfig.yxqxJs"
                    :disabled="step == 5"
                    type="date"
                    placeholder="选择日期"
                    style="marign-right: 20px"
                    value-format="yyyy-MM-dd"
                    :picker-options="this.endTime(paramConfig.yxqxKs)"
                  />
                  <!-- <el-checkbox
                    v-if="step != 5"
                    style="position: absolute; left: 5px; top: 40px"
                    v-model="cqyxIsOrNot"
                    @change="cqyxChange(cqyxIsOrNot)"
                    >长期有效</el-checkbox
                  > -->
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="发证机关:" prop="fzjg">
                  <el-input
                    v-model="paramConfig.fzjg"
                    :disabled="step == 5"
                    placeholder="请输入机关名称"
                    maxlength="100"
                  />
                </el-form-item>
              </div></div></el-form>
          <div class="topTitle">其他信息</div>
          <el-form
            ref="frFormBottom"
            class="formConBottom"
            label-position="left"
            :model="paramConfig"
            :rules="rules"
            label-width="85px"
          >
            <div style="display: flex">
              <div style="width: 458px; margin-right: 69px">
                <el-form-item label="办公电话:" prop="bgdh">
                  <el-input
                    v-model="paramConfig.bgdh"
                    :disabled="step == 5"
                    placeholder="请输入办公电话"
                    maxlength="30"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px" class="ipone">
                <el-form-item label="手机号码:" prop="sjhm">
                  <el-input
                    v-model="paramConfig.sjhm"
                    :disabled="step == 5"
                    placeholder="请输入手机号码"
                  />
                </el-form-item>
              </div>
            </div>
            <div style="min-width: 945px">
              <el-form-item label="实际住址:" prop="sjzz">
                <el-input
                  v-model="paramConfig.sjzz"
                  :disabled="step == 5"
                  type="textarea"
                  :rows="1"
                  placeholder="请输入实际住址"
                  resize="none"
                  maxlength="200"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div v-else class="content">
        <div class="idCardInformation">
          <div class="topTitle">证件信息</div>
          <el-form
            ref="frForm"
            class="formCon"
            :model="paramConfig"
            :rules="rules"
            label-position="left"
            label-width="98px"
          >
            <div style="display: flex">
              <div style="margin-right: 69px">
                <el-form-item label="姓名:" prop="xm">
                  <el-input
                    v-model="paramConfig.xm"
                    :disabled="step == 5"
                    placeholder="请输入姓名"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="性别:" prop="xb">
                  <el-select
                    v-model="paramConfig.xb"
                    :disabled="step == 5"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in sexOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div style="margin-right: 69px">
                <!-- 文静说 其他证件  证件号码必填 内容不做校验 prop="zjhm" -->
                <el-form-item label="证件号码:" prop="zjhm" class="is-required">
                  <el-input
                    v-model="paramConfig.zjhm"
                    :disabled="step == 5"
                    placeholder="请输入证件号码"
                    maxlength="50"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="证件名称:" class="is-required" prop="qtzj">
                  <el-select
                    v-model="paramConfig.qtzj"
                    :disabled="step == 5"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in zjNameOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div style="margin-right: 69px">
                <el-form-item label="出生日期:" prop="sr">
                  <el-date-picker
                    v-model="paramConfig.sr"
                    :disabled="step == 5"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择出生日期"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="民族:">
                  <el-select
                    v-model="paramConfig.mz"
                    :disabled="step == 5"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in mzOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex">
              <div class="dateReal">
                <el-form-item
                  style="position: relative"
                  label="有效期限:"
                  label-width="98px"
                  prop="yxqxKs"
                >
                  <el-date-picker
                    v-model="paramConfig.yxqxKs"
                    :disabled="step == 5"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="this.startTime(paramConfig.yxqxJs)"
                  />
                  <div
                    class=""
                    style="
                      display: inline-block;
                      width: 35px;
                      height: 39px;
                      line-height: 39px;
                      text-align: center;
                    "
                  >
                    至
                  </div>
                  <el-date-picker
                    v-model="paramConfig.yxqxJs"
                    :disabled="step == 5"
                    type="date"
                    placeholder="选择日期"
                    style="marign-right: 20px"
                    value-format="yyyy-MM-dd"
                    :picker-options="this.endTime(paramConfig.yxqxKs)"
                  />
                  <!-- <el-checkbox
                    v-if="step != 5"
                    style="position: absolute; left: 5px; top: 40px"
                    v-model="cqyxIsOrNot"
                    @change="cqyxChange(cqyxIsOrNot)"
                    >长期有效</el-checkbox
                  > -->
                </el-form-item>
              </div>
              <div style="margin-right: 69px">
                <el-form-item label="发证机关:" prop="fzjg">
                  <el-input
                    v-model="paramConfig.fzjg"
                    :disabled="step == 5"
                    placeholder="请输入机关名称"
                    maxlength="100"
                  />
                </el-form-item>
              </div></div></el-form>
          <div class="topTitle">其他信息</div>
          <el-form
            ref="frFormBottom"
            class="formConBottom"
            label-position="left"
            :model="paramConfig"
            :rules="rules"
            label-width="85px"
          >
            <div style="display: flex">
              <div style="width: 458px; margin-right: 69px">
                <el-form-item label="办公电话:" prop="bgdh">
                  <el-input
                    v-model="paramConfig.bgdh"
                    :disabled="step == 5"
                    placeholder="请输入办公电话"
                    maxlength="30"
                  />
                </el-form-item>
              </div>
              <div style="margin-right: 69px" class="ipone">
                <el-form-item label="手机号码:" prop="sjhm">
                  <el-input
                    v-model="paramConfig.sjhm"
                    :disabled="step == 5"
                    placeholder="请输入手机号码"
                  />
                </el-form-item>
              </div>
            </div>
            <div style="min-width: 945px">
              <el-form-item label="实际住址:" prop="sjzz">
                <el-input
                  v-model="paramConfig.sjzz"
                  :disabled="step == 5"
                  type="textarea"
                  :rows="1"
                  placeholder="请输入实际住址"
                  resize="none"
                  maxlength="200"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div v-if="step != 5" class="_buttonList">
        <el-button v-preventReClick @click="upstep">上一步</el-button>
        <el-button
          v-preventReClick
          style="background-color: #4170ff; color: white"
          type="primary"
          @click="submitFRForm('frForm', 'frFormBottom')"
        >下一步</el-button>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogLeftVisible"
      width="400px"
    >
      <img width="100%" :src="imageUrlOface" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getkv,
  saveFrxx,
  getfrrzxx,
  getToken,
  returnSaveFile, returnShowPic
} from '@/assets/js/common.js'
import { startTime, endTime, lengthValidate } from '@/assets/js/validate.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'

export default {
  name: 'Setps3',
  props: {
    step: Number
  },
  data() {
    const jgjiaoyan = (rule, value, callback) => {
      if (this.jgNum.length == 0) {
        callback(new Error('请选择籍贯!'))
      } else {
        callback()
      }
    }
    var validateCard = (rule, value, callback) => {
      if (this.cardType == 1) {
        if (!value) {
          callback(new Error('请输入证件号码'))
        } else {
          if (!this.IdentityCodeValid(value)) {
            callback(new Error('请输入正确的身份证号码'))
          } else {
            callback()
          }
        }
      } else if (this.cardType == 4) {
        lengthValidate(rule, value, callback, 'bt', 100)
        if (!this.paramConfig.zjhm) {
          callback(new Error('请输入证件号码'))
        } else {
          callback()
        }
      }
    }
    const telphoneValidate = (rule, value, callback) => {
      if (!this.paramConfig.sjhm) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (value) {
        if (!reg1.test(value) && !reg2.test(value)) {
          callback(new Error('请输入正确的电话或手机号格式'))
        }
      }
      callback()
    }
    return {
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 100)
        }
      },
      sfzLoading: true,
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '',
      // jiekou
      leftimg: '',
      rightimg: '',
      centerImg: '',
      sexOptions: [
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      mzOptions: [],
      jgOptions: [], // 籍贯集合
      zjNameOptions: [], // 证件名称
      jgNum: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          const endDateVal = this.paramConfig.yxqxJs
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          const beginDateVal = this.paramConfig.yxqxKs
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime()
          }
        },
        shortcuts: [
          {
            text: '长期有效',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      zjTypeOptions: undefined, // 证件类型
      jgAddress: '',
      dialogLeftVisible: false, // 人脸大图
      paramConfig: {
        id: '',
        dwid: '',
        xm: '',
        zw: '',
        jg: '',
        sjzz: '',
        bgdh: '',
        sjhm: '',
        zjlx: '1',
        qtzj: '',
        zjhm: '',
        xb: '',
        mz: '',
        sr: '',
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        zjzpZm: '',
        zjzpFm: ''
      },
      // jiekou
      cardType: 1,
      // 校验规则
      rules: {
        bgdh: [{ validator: phoneValidator, trigger: ['blur', 'change'] }],
        xm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        xb: [{ required: true, message: '请选择性别', trigger: ['blur'] }],
        // mz:[{ required: true, message: "请选择民族123", trigger: ["change"] }],
        sr: [{ required: true, message: '请选择出生日期', trigger: 'blur' }],
        zjhm: [
          {
            required: true,
            validator: validateCard,
            trigger: ['blur', 'change']
          }
        ],
        qtzj: [{ required: true, message: '请选择', trigger: 'blur' }],
        jgNum: [
          {
            validator: jgjiaoyan,
            type: 'array',
            trigger: 'blur'
          }
        ],
        mz: [{ required: true, message: '请选择民族', trigger: 'blur' }],
        yxqxKs: [
          { required: true, message: '请选择有效期限', trigger: 'blur' }
        ],
        yxqxJs: [
          { required: true, message: '请选择结束期限', trigger: 'blur' }
        ],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        sjhm: [
          // { required: true, message: "请输入姓名", trigger: "blur" }
          {
            required: true,
            validator: telphoneValidate,
            trigger: ['blur', 'change'],
            min: 11,
            max: 11
          }
        ]
      },
      imageUrlOfZG: '', // 证件国徽面
      imageUrlOface: '', // 证件人像面
      imageUrlOfPublic: '', // 一般证件
      isShowLeftDelete: false,
      isShowRightDelete: false,
      isShowCenterDelete: false,
      dialogTableVisible: false,
      dialogFormVisible: true
    }
  },
  computed: {
    ...mapState(['RWLCType'])
  },
  created() {
    this.returnSaveFile = returnSaveFile()
  },
  mounted() {
    this.initFr()
  },
  beforeDestroy() {
    this.$refs['frForm'].resetFields()
    this.$refs['frFormBottom'].resetFields()
  },
  methods: {
    lengthValidate,
    startTime,
    endTime,
    IdentityCodeValid(code) {
      // 验证身份证合法性
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      var pass = true

      var patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!code || !patt1.test(code)) {
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            pass = false
          }
        }
      }
      return pass
    },
    typeChange(newValue) {
      /* this.$nextTick(() => {
        this.$refs["frForm"].resetFields();
        this.$refs["frFormBottom"].resetFields();
      }); */
      var picIndexStr = returnShowPic()+''
      if (newValue == 1) {
        // @y1126
        this.paramConfig.zjzpZm = ''
        if (this.imageUrlOface && this.imageUrlOface.indexOf(picIndexStr) != -1) {
          this.paramConfig.zjzpZm = this.imageUrlOface.slice(picIndexStr.length);
        }
        this.paramConfig.zjzpFm = ''
        if (this.imageUrlOfZG && this.imageUrlOfZG.indexOf(picIndexStr) != -1) {
          this.paramConfig.zjzpFm = this.imageUrlOfZG.slice(picIndexStr.length)
        }
      } else if (newValue == 4) {
        this.paramConfig.zjzpZm = ''
        if (this.imageUrlOfPublic && this.imageUrlOfPublic.indexOf(picIndexStr) != -1) {
          this.paramConfig.zjzpZm = this.imageUrlOfPublic.slice(picIndexStr.length)
        }
        this.imageUrlOfPublic = this.imageUrlOfPublic
          ? this.imageUrlOfPublic
          : require('../assets/img/zjrlx.png')
      }
    },
    initFr() {
      // 证件类型
      getkv('yzd_zjlx').then((e) => {
        this.zjTypeOptions = e.data
      })
      // 民族
      getkv('yzd_mz').then((e) => {
        this.mzOptions = e.data.data
      })
      // 证件名称
      getkv('yzd_ry_zjmc').then((e) => {
        this.zjNameOptions = e.data.data
      })
      // 获取籍贯
      // getjg().then(e => {
      //   this.jgOptions = e.data.data;
      // });

      // 初始化法人/经营者信息
      getfrrzxx(this.RWLCType).then((res) => {
        // @y1124
        this.sfzLoading = false
        const baseImgUrl = returnShowPic()
        this.paramConfig = res.data.data
        this.cardType = !this.paramConfig.zjlx
          ? 1
          : parseInt(this.paramConfig.zjlx)
        // @y1124身份证
        const zhengM = require('../assets/img/zjrlx.png')
        const fanM = require('../assets/img/zjghx.png')
        if (res.data.data.jg != '' && res.data.data.jg != null) {
          this.jgNum = res.data.data.jg.split(',').map(Number)
        }
        // @y1124身份证
        if (this.cardType == 1) {
          // 身份证
          this.imageUrlOface = !this.paramConfig.zjzpZm
            ? zhengM
            : baseImgUrl + this.paramConfig.zjzpZm
          this.imageUrlOfZG = !this.paramConfig.zjzpFm
            ? fanM
            : baseImgUrl + this.paramConfig.zjzpFm
        } else if (this.cardType == 4) {
          // 其他证件
          this.imageUrlOfPublic = !this.paramConfig.zjzpZm
            ? zhengM
            : baseImgUrl + this.paramConfig.zjzpZm
        }
        // 籍贯
        // this.jgNum = !res.data.data.jg ? [] : res.data.data.jg.split(",");
      })
    },
    // 人脸面
    handlePictureCardPreview(file) {
      this.imageUrlOface = file.url
      this.dialogLeftVisible = true
    },
    // 国徽面
    handlePictureCardBacPreview(file) {
      this.imageUrlOfZG = file.url
    },
    // @y1124
    apiControl() {
      this.sfzLoading = true
      this.paramConfig.zjlx = this.cardType
      const curParam = this.paramConfig
      saveFrxx(curParam, this.RWLCType)
        .then((res) => {
          this.sfzLoading = false
          this.$emit('nextstep', 4)
        })
        .catch((err) => {
          this.sfzLoading = false
          return err
        })
    },
    // 提交表单
    submitFRForm(formValidate, frFormBottom) {
      let statusOfSusOne = false
      let statusOfSusTwo = false
      //  证件照上传@y1124
      this.$refs[formValidate].validate((valid) => {
        statusOfSusOne = valid
      })
      this.$refs[frFormBottom].validate((valid) => {
        statusOfSusTwo = valid
      })
      // @y 1124
      const templetFlag = statusOfSusOne && statusOfSusTwo
      if (templetFlag) {
        //  this.apiControl();// 不校验上传
        // 校验通过
        if (this.cardType == 1) {
          // 身份证
          if (!this.paramConfig.zjzpZm || !this.paramConfig.zjzpFm) {
            this.$message({
              message: '请上传证件照',
              type: 'warning'
            })
          } else {
            this.apiControl()
          }
        } else if (this.cardType == 4) {
          // 其他证件
          if (!this.paramConfig.zjzpZm) {
            this.$message({
              message: '请上传证件照',
              type: 'warning'
            })
          } else {
            this.apiControl()
          }
        }
      }
    },
    // 切换籍贯
    jgChange(val) {
      this.jgNum = val.join(',')
      this.paramConfig.jg = this.jgNum
    },
    removeCurImg(type) {
      if (type == 'gh') {
        this.imageUrlOfZG = ''
        this.paramConfig.zjzpFm = ''
        this.isShowRightDelete = false
      } else if (type == 'rl') {
        this.imageUrlOface = ''
        this.paramConfig.zjzpZm = ''
        this.isShowLeftDelete = false
      } else {
        this.imageUrlOfPublic = ''
        this.paramConfig.zjzpZm = ''
        this.isShowCenterDelete = false
      }
    },
    // 上一步
    upstep() {
      // 'frForm', 'frFormBottom'
      this.$nextTick(() => {
        this.$refs['frForm'].resetFields()
        this.$refs['frFormBottom'].resetFields()
      })

      this.$emit('nextstep', 2)
    },
    // 证件人像面
    handleFaceAvatarScuccess(res, file) {
      this.imageUrlOface = URL.createObjectURL(file.raw)
      if (this.imageUrlOface !== '') {
        this.isShowLeftDelete = true
        this.leftimg = res.data.url
        // @y1124
        this.paramConfig.zjzpZm = res.data.url
        if (res.data.ocrFlag) {
          this.$message.success('证件上传成功')
          /*  this.paramConfig.mz = res.data.oneData.mz;
          this.paramConfig.sjzz = res.data.oneData.sjzz;
          this.paramConfig.sr = res.data.oneData.sr;
          this.paramConfig.xb = res.data.oneData.xb;
          this.paramConfig.xm = res.data.oneData.xm;
          this.paramConfig.zjhm = res.data.oneData.zjhm; */
        } else {
          // this.$message.warning("证件上传成功,但无法识别!请手动填写!");
        }
      }
    },
    // 国徽
    handleZGAvatarScuccess(res, file) {
      this.imageUrlOfZG = URL.createObjectURL(file.raw)
      if (this.imageUrlOfZG !== '') {
        this.isShowRightDelete = true
        this.rightimg = res.data.url
        // @y1124
        this.paramConfig.zjzpFm = res.data.url
        if (res.data.ocrFlag) {
          this.$message.success('证件上传成功')
          /*    this.paramConfig.fzjg = res.data.oneData.fzjg;
          this.paramConfig.yxqxJs = res.data.oneData.yxqxJs;
          this.paramConfig.yxqxKs = res.data.oneData.yxqxKs; */
        } else {
          // this.$message.warning("证件上传成功,但无法识别!请手动填写!");
        }
      } else {
        this.$message.error('证件上传失败')
      }
    },
    // 普通证件
    handlePublicAvatarScuccess(res, file) {
      this.imageUrlOfPublic = returnShowPic() + res.data.url
      // @y1124
      this.paramConfig.zjzpZm = res.data.url
      this.isShowCenterDelete = true
      this.$message.success('证件上传成功！')
    },
    // 上传之前校验
    beforeAvatarUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    }
  }
}
</script>

<style lang="less" scoped>
.step3Container {
  height: 1102px;
  box-sizing: border-box;
  padding: 50px 30px 80px 30px;
  position: relative;
  background-color: #fff;
  .mainContainer {
    max-width: 945px;
    width: 90%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    box-sizing: border-box;
    .top {
      /deep/.el-form-item__label:before {
        color: #2860ec;
      }
      height: 387px;
      box-sizing: border-box;
      .title {
        // width: 235px;
        height: 30px;
        position: absolute;
        left: 50%;
        top: 50px;
        transform: translateX(-50%);
        font-size: 25px;
        line-height: 30px;
        font-family: "Helvetica";
        letter-spacing: 0;
      }
      .cardform {
        position: absolute;
        left: 50%;
        top: 105px;
        height: 38px;
        transform: translateX(-50%);
        /deep/.el-radio__input.is-checked .el-radio__inner {
          border-color: none;
          background: url("../assets/img/radiobox_down.png");
          background-size: 100% 100%;
        }
        /deep/.el-radio__input .el-radio__inner {
          border-color: none;
          background: url("../assets/img/radiobox.png");
          background-size: 100% 100%;
          border-radius: 0;
          border: none;
        }
        /deep/.el-radio__input.is-checked .el-radio__inner::after {
          content: "";
          background: none;
        }
      }
      .uploadImage {
        display: flex;
        width: 100%;
        height: 160px;
        border-radius: 3px;
        box-sizing: border-box;
        position: absolute;
        left: 0px;
        top: 181px;
        .left {
          width: 50%;
          .uploadLeftContainer {
            position: absolute;
            left: 201px;
            top: 0;
            width: 223px;
            height: 137px;
          }
          .avatar-uploader .el-upload {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 223px;
            height: 137px;
            position: absolute;
            left: 301px;
            top: 0;
            background: #f1f8fe;
            border-radius: 3px;
          }
          img {
            width: 223px;
            height: 137px;
            overflow: hidden;
          }
          .avatar-uploader .el-upload:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: 0px;
            color: #8c939d;
            width: 223px;
            height: 137px;
            line-height: 137px;
            text-align: center;
          }
          .avatar {
            width: 223px;
            height: 137px;
            display: block;
          }
          .instruction {
            width: 70px;
            height: 20px;
            font-size: 14px;
            position: absolute;
            left: 277px;
            bottom: 0;
            font-family: "PingFangSC-Regular, PingFang SC";
            font-weight: 400;
            color: #636363;
            line-height: 20px;
          }
        }
        .right {
          width: 50%;
          .uploadRightContainer {
            position: absolute;
            left: 576px;
            top: 0;
          }
          .avatar-uploader .el-upload {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 223px;
            height: 137px;
            background: #f1f8fe;
            border-radius: 3px;
          }
          /deep/.el-upload {
          }
          .avatar-uploader .el-upload:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: 0px;
            color: #8c939d;
            width: 223px;
            height: 137px;
            overflow: hidden;
            line-height: 137px;
            text-align: center;
            position: absolute;
            left: 576px;
            top: 0;
            background-image: url("../assets/img/zjghx.png");
            background-size: 100% 100%;
          }
          .avatar {
            width: 223px;
            height: 137px;
            display: block;
          }
          .instruction {
            width: 70px;
            height: 20px;
            font-size: 14px;
            position: absolute;
            left: 652px;
            bottom: 0;
            font-family: "PingFangSC-Regular, PingFang SC";
            font-weight: 400;
            color: #636363;
            line-height: 20px;
          }
        }
        .centerImg {
          margin: 0 auto;
          position: relative;
          .instructionCenter {
            margin: 0 auto;
            text-align: center;
          }
          .deleteUploadOther {
            width: 25px;
            height: 25px;
            position: absolute;
            right: 0;
            top: 15px;
            cursor: pointer;
          }
          .avatar-uploader .el-upload {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width: 223px;
            height: 137px;
            position: absolute;
            left: 301px;
            top: 0;
            background: #f1f8fe;
            border-radius: 3px;
          }
          img {
            width: 223px;
            height: 137px;
            overflow: hidden;
          }
          .avatar-uploader .el-upload:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: 0px;
            color: #8c939d;
            width: 223px;
            height: 137px;
            line-height: 137px;
            text-align: center;
          }
          .avatar {
            width: 223px;
            height: 137px;
            display: block;
          }
        }
        .deleteUpload {
          width: 25px;
          height: 25px;
          position: absolute;
          right: 0;
          top: 15px;
          cursor: pointer;
          // background: #2860ec;
          z-index: 13;
        }
      }
    }

    .content {
      box-sizing: border-box;
      padding: 30px 0px;
      .idCardInformation {
        width: 100%;
        height: 100%;
        .topTitle {
          height: 40px;
          line-height: 40px;
          font-weight: 700;
          margin-bottom: 30px;
        }
        .formCon {
          width: 100%;
          height: 250px;
          .dateReal {
            width: 908px;
            display: flex;
            /deep/.el-date-editor {
              width: 152.5px;
            }
            /deep/.el-input__inner {
              width: 152.5px;
            }
            /deep/.el-form-item__content {
              width: 400px;
              margin-right: 10px;
            }
          }
        }
        .formConBottom {
          height: 130px;

          /deep/.el-input__inner {
            width: 353px;
            box-sizing: border-box;
          }
          /deep/.el-form-item .is-required {
            box-sizing: border-box;
          }
        }
      }
    }
    ._buttonList {
      width: 100%;
      display: flex;
      justify-content: center;
      button {
        width: 148px;
        height: 60px;
      }
      button:nth-child(2) {
        margin-left: 190px;
      }
    }
    /deep/.el-input__inner {
      width: 340px;
      height: 39px;
      border-radius: 2px;
    }
    /deep/.el-radio__input.is-checked + .el-radio__label {
      width: 45px;
      height: 21px;
      font-size: 15px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      // color: #333333;
      line-height: 21px;
    }
    /deep/.el-form-item__label {
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      // color: #333;
    }
    /deep/.el-radio__label {
      // color: #333;
    }
  }
  .el-form-item:last-child {
    .el-input__inner {
      width: 860px;
    }
  }
  /deep/ .ipone .el-form-item__label {
    width: 88px !important;
  }
  /deep/ .ipone .el-input__inner {
    width: 340px !important;
  }
  /deep/ .ipone .el-form-item__content {
    margin-left: 98px !important;
    width: 340px;
  }
  /deep/.el-textarea {
    width: 860px;
    border-radius: 2px;
    font-family: "PingFangSC-Regular, PingFang SC";
  }
  /deep/.el-textarea__inner {
    padding: 8px 15px;
    height: 39px;
    border-radius: 2px;
    font-family: "PingFangSC-Regular, PingFang SC";
  }
  /deep/.el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 340px;
  }
}
</style>
